import { render, staticRenderFns } from "./TrainingQualificationRecordDetails.vue?vue&type=template&id=bc09f2f6"
import script from "./TrainingQualificationRecordDetails.vue?vue&type=script&lang=ts"
export * from "./TrainingQualificationRecordDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports